"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolHistoricalBars = exports.HistoricalBars = exports.HistoricalBar = void 0;
class HistoricalBar {
    constructor(obj) {
        for (const prop in obj) {
            const lowercaseName = prop.substr(0, 1).toLocaleLowerCase() + prop.substr(1);
            this[lowercaseName] = obj[prop];
        }
    }
}
exports.HistoricalBar = HistoricalBar;
class HistoricalBars {
    constructor(bars) {
        this.bars = bars;
        this.total = bars.length;
    }
}
exports.HistoricalBars = HistoricalBars;
class SymbolHistoricalBars {
}
exports.SymbolHistoricalBars = SymbolHistoricalBars;
//# sourceMappingURL=HistoricalBar.js.map